<template>
  <div>
    <h1>Signing in...</h1>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { reloadApp, usePageTitle } from '@/util/AppUtil'
import { useTokenManager } from '@/auth/TokenManager'
import { LocalTokenApi } from './LocalTokenApi'
import { useTelemetry } from '@/util/Telemetry'

usePageTitle("Signing in")

const tokenManager = useTokenManager()
const { trackEvent } = useTelemetry()

async function exchangeToken() {
  const urlParams = new URLSearchParams(window.location.search)
  const accessToken = urlParams.get('access_token')
  const clientId = urlParams.get('client_id')
  const code = urlParams.get('code')

  if (accessToken) {
    await tokenManager.exchangeToken(accessToken)
  }
  else if (clientId && code) {
    const response = await LocalTokenApi.getLocalAccessTokenFromAuthCodeAsync(clientId, code)
    trackEvent('AuthCodeUsed')
    tokenManager.setCurrentTokenFromResponse(response)
  }

  let path = urlParams.get('redirect_uri')
  if (!path?.startsWith("/")) { // SECURITY: allow ONLY relative paths
    path = "/home"
  }

  // sign in complete, so navigate to target path
  reloadApp(path)
}

onMounted(() => {
  exchangeToken()
})
</script>
